export default __webpack_public_path__ + "static/media/uploadRevenue.ee2c2402.svg";